module.exports = __webpack_public_path__ + "static/media/openengine-video-1.59c8fde2.svg";